import { render, staticRenderFns } from "./HistoricalCentresAnalysis.vue?vue&type=template&id=380b749c&scoped=true&"
import script from "./HistoricalCentresAnalysis.vue?vue&type=script&lang=ts&"
export * from "./HistoricalCentresAnalysis.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricalCentresAnalysis.vue?vue&type=style&index=0&id=380b749c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380b749c",
  null
  
)

export default component.exports